import { Link } from "react-router-dom";

export const QuietCTA = () => (
  <section className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 sm:pt-24 pb-16 sm:pb-24" data-testid="quiet-cta">
    <div className="grid grid-cols-1 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <Link
          to="/contact"
          data-testid="tell-us-link"
          className="font-display text-3xl sm:text-4xl text-plaster hover:text-ink transition-colors duration-200"
        >
          Tell us about your project.
        </Link>
      </div>
    </div>
  </section>
);
